import axios from 'axios';
import { loginreq, req } from './axiosFun';

// 登录接口
export const login = (params) => { return loginreq("post", "/huichen-ui/sys/login", params) };

// 登录接口
export const code =(params) => { return loginreq("post", "/huichen-ui/sys/code",params) };

// 查询程序配置
export const programRule = (params) => { return loginreq("post", "/huichen-ui/sys/programRule", params) };

// 退出接口
export const loginout = (params) => { return req("post", "/huichen-ui/sys/loginout", params) };

// 用户菜单
export const qryMenuByRole = (params) => { return req("post", "/huichen-ui/sys/qryMenuByRole", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js